import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FaireMarketIcon } from "@faire/retailer-visitor-shared/features/FaireMarkets/FaireMarketIcon";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web--source/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { EventsThemeLogo } from "@faire/web--source/slate/Theme/EventsThemeLogo";
import { EventsThemeShapeCombination } from "@faire/web--source/slate/Theme/EventsThemeShapeCombination";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useQuery as usePromotionalEventBrandParticipatingStatusQuery } from "@faire/web-api--source/api/v2/brands/promotional-event/eventType/brands/brandToken/participating-status/get-hooks";
import { url as faireMarketsUrl } from "@faire/web-api--source/routes/www/markets";
import differenceInDays from "date-fns/differenceInDays";
import React from "react";
import styled from "styled-components";
var DEFAULT_TEXT_COLOR = getEventTheme("faireMarket").promoTextInverse;
export var MarketEventDirectSection = function(param) {
    var brandToken = param.brandToken;
    var _useMarketStore = useMarketStore([
        "currentEventType",
        "marketName",
        "mainEventEndAt",
        "earlyAccessStartAt"
    ]), currentEventType = _useMarketStore.currentEventType, marketName = _useMarketStore.marketName, mainEventEndAt = _useMarketStore.mainEventEndAt, earlyAccessStartAt = _useMarketStore.earlyAccessStartAt;
    var _useMarketStore1 = useMarketStore([
        "latestMarketMainEventRangeDate"
    ]), mainEventRangeDate = _useMarketStore1.latestMarketMainEventRangeDate;
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTabletAndAbove = _useViewport.isTabletAndAbove;
    var data = usePromotionalEventBrandParticipatingStatusQuery(currentEventType, brandToken).data;
    var learnMoreLink = useGenerateLearnMoreFaireDirectLink();
    var learnMoreText = /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "yXtgGi",
        defaultMessage: [
            {
                type: 0,
                value: "Learn More"
            }
        ]
    });
    var shouldShowBanner = !!(data === null || data === void 0 ? void 0 : data.brand_participating_status);
    if (!shouldShowBanner) {
        return null;
    }
    var _getEventTheme_decorative6, _getEventTheme_decorative5;
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: FaireMarketTheme,
        children: /*#__PURE__*/ _jsxs(FullWidthWrapper, {
            children: [
                /*#__PURE__*/ _jsx(StyledMarketShapeCombo, {
                    frontShapeColor: (_getEventTheme_decorative6 = getEventTheme("faireMarket").decorative6) !== null && _getEventTheme_decorative6 !== void 0 ? _getEventTheme_decorative6 : "",
                    backShapeColor: (_getEventTheme_decorative5 = getEventTheme("faireMarket").decorative5) !== null && _getEventTheme_decorative5 !== void 0 ? _getEventTheme_decorative5 : "",
                    width: "308px",
                    height: "194px"
                }),
                isMobile ? /*#__PURE__*/ _jsx(MobileMarketIcon, {}) : null,
                /*#__PURE__*/ _jsxs(Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                isMobile ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(StyledMarketPrimaryLogo, {
                                            isInverse: true
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "9x"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Content, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: {
                                                mobileAndAbove: "paragraphSansMedium",
                                                tabletAndAbove: "subheadingSansMedium"
                                            },
                                            color: DEFAULT_TEXT_COLOR,
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "0c6jtm",
                                                defaultMessage: [
                                                    {
                                                        type: 1,
                                                        value: "mainEventRangeDate"
                                                    },
                                                    {
                                                        type: 0,
                                                        value: ", plus Insider early access"
                                                    }
                                                ],
                                                values: {
                                                    mainEventRangeDate: mainEventRangeDate
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            height: "1x"
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "displaySSerifRegular",
                                            color: DEFAULT_TEXT_COLOR,
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "xkNY+T",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "We'll be at "
                                                    },
                                                    {
                                                        type: 1,
                                                        value: "marketEventName"
                                                    },
                                                    {
                                                        type: 0,
                                                        value: "!"
                                                    }
                                                ],
                                                values: {
                                                    marketEventName: marketName
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            height: "1x"
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "paragraphSansRegular",
                                            color: DEFAULT_TEXT_COLOR,
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "7aBGRV",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Shop the best deals on our brand at Faire\u2019s 4-day virtual trade show. The event is free for all Faire retailers!"
                                                    }
                                                ],
                                                values: {
                                                    daysNumber: differenceInDays(mainEventEndAt, earlyAccessStartAt) + 1
                                                }
                                            })
                                        }),
                                        isMobile ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Spacer, {
                                                    height: "1x"
                                                }),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "paragraphSansRegular",
                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                        variant: "tertiary",
                                                        tertiaryColor: DEFAULT_TEXT_COLOR,
                                                        linkTo: learnMoreLink,
                                                        children: learnMoreText
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        isTabletAndAbove ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "2x"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "secondary",
                                    linkTo: learnMoreLink,
                                    children: learnMoreText
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var useGenerateLearnMoreFaireDirectLink = function() {
    var faireDirectBrandAlias = useFaireDirectBrand().faireDirectBrandAlias;
    var link = faireMarketsUrl();
    if (faireDirectBrandAlias) {
        link += "?".concat(FAIRE_DIRECT_BRAND_QUERY_PARAM, "=").concat(faireDirectBrandAlias);
    }
    return link;
};
var FullWidthWrapper = styled.div.withConfig({
    componentId: "sc-a23c56f7-0"
})([
    "position:relative;background-color:",
    ";overflow:hidden;padding:",
    ";",
    "{padding:",
    ";}"
], getEventTheme("faireMarket").primaryDark, getSpacing("4x", "3x"), responsiveMediaQueries.tabletAndAbove, getSpacing("8x", 96));
var Wrapper = styled(Column).withConfig({
    componentId: "sc-a23c56f7-1"
})([
    "position:relative;",
    "{margin:0 auto;max-width:1120px;}"
], responsiveMediaQueries.desktopAndAbove);
var Content = styled(Column).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-a23c56f7-2"
})([
    "max-width:471px;z-index:1;padding-right:",
    ";"
], getSpacing("6x"));
var StyledMarketPrimaryLogo = styled(EventsThemeLogo.faireMarket.primary).withConfig({
    componentId: "sc-a23c56f7-3"
})([
    "width:136px;height:auto;margin-bottom:",
    ";",
    "{width:96px;margin-bottom:",
    ";}"
], getSpacing("3x"), responsiveMediaQueries.mobile, getSpacing("2x"));
var StyledMarketShapeCombo = styled(EventsThemeShapeCombination.faireMarket.comboA).withConfig({
    componentId: "sc-a23c56f7-4"
})([
    "position:absolute;right:-96px;bottom:0;&&&{",
    "{display:none;}}"
], responsiveMediaQueries.tabletAndBelow);
var MobileMarketIcon = styled(FaireMarketIcon).attrs({
    color: getEventTheme("faireMarket").secondary,
    size: "92px"
}).withConfig({
    componentId: "sc-a23c56f7-5"
})([
    "position:absolute;right:-32px;"
]);
